import React from 'react';
import InterfacesDiagram from '../components/InterfacesDiagram';

/** Map of {token} names to inline React components */
const inlineComponents: Record<string, React.FC> = {
  interfaces: InterfacesDiagram,
};

/**
 * Renders a plain string that may contain:
 *   - markdown-style links: [text](url)
 *   - inline components:    {interfaces}
 */
export function renderLinks(text: string): React.ReactNode {
  // Split on both [link](url) and {token} patterns
  const parts = text.split(/(\[[^\]]+\]\([^)]+\)|\{[a-zA-Z-]+\})/g);
  if (parts.length === 1) return text;

  return (
    <>
      {parts.map((part, i) => {
        // Markdown link
        const linkMatch = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (linkMatch) {
          return (
            <a key={i} href={linkMatch[2]} target="_blank" rel="noopener noreferrer">
              {linkMatch[1]}
            </a>
          );
        }
        // Inline component token
        const tokenMatch = part.match(/^\{([a-zA-Z-]+)\}$/);
        if (tokenMatch) {
          const Component = inlineComponents[tokenMatch[1]];
          if (Component) return <Component key={i} />;
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </>
  );
}
